import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { v4 as uuid4 } from 'uuid';
import { urls } from 'app-constants';
import { useBootstrapBreakpoint, useGetAPI, useHistory, useOrderingMenu } from 'hooks';
import { statusOptions, activeStatusVals } from './statusOptions';
import LoadingOverlay from 'components/LoadingOverlay';
import Item from './Item';
import StatusFilter from './StatusFilter';

const ORDER_CREATED = '-created';
const ORDER_UPDATED = '-updated';
const DEFAULT_ORDER = ORDER_CREATED;

const VenueModeration = () => {
  const { location: { queryParams }, updateQueryParams } = useHistory();
  const { orderingVal, orderingMenu } = useOrderingMenu({
    options: [
      { label: 'Created', value: ORDER_CREATED },
      { label: 'Updated', value: ORDER_UPDATED },
    ],
    defaultValue: DEFAULT_ORDER,
  });

  const [cacheKey, setCacheKey] = useState(uuid4());
  const updateCacheKey = () => setCacheKey(uuid4())

  // Call API
  let path;
  let apiParams = { ordering: orderingVal };
  if (typeof queryParams !== 'undefined') {
    path = urls.poiClaimModerationList;
    apiParams = ['all', 'status'].reduce((result, key) => {
      if (typeof queryParams[key] !== 'undefined') {
        result[key] = queryParams[key];
      }
      return result;
    }, apiParams);
  }
  const { data, isFetching, error } = useGetAPI(path, {
    queryObject: apiParams,
    fullPath: true,
    extraDeps: [orderingVal, cacheKey],
  });

  let statusFilterVal = [];
  if (typeof queryParams !== 'undefined') {
    statusFilterVal = queryParams.status
      ? queryParams.status.split(',').filter(s => statusOptions.includes(s))
      : activeStatusVals;
  }

  const handleStatusFilterChange = val => {
    updateQueryParams({ status: val.length ? val.join(',') : null });
  }

  const [errorMessage, setErrorMessage] = useState(null);
  const handleDeleteFailure = errorText => setErrorMessage(`Failed to delete item: ${errorText || 'unknown error'}`);

  const isMobile = useBootstrapBreakpoint('down-md');
  const showEmptyMessage = data && data.length === 0 && !isFetching;
  const HeadingTag = isMobile ? 'h4' : 'h2';

  return (
    <div className="py-4">
      <LoadingOverlay show={isFetching} align="top" className="bg-lt" />
      <header>
        <HeadingTag className="lh-base fw-black">Manage Producer Requests</HeadingTag>

        <div className={classNames(
          'd-flex',
          'mb-1',
          'align-items-baseline',
          `justify-content-${isMobile ? 'end' : 'between'}`,
        )}>
          {!isMobile && (
            <StatusFilter
              value={statusFilterVal}
              onChange={handleStatusFilterChange}
            />
          )}
          {orderingMenu}
        </div>

        {!!error && (
          <div className="alert alert-danger mb-3" role="alert">
            Failed to fetch results. Please try your request again.
          </div>
        )}

        {!!errorMessage && (
          <div className="alert alert-danger mb-3" role="alert">
            {errorMessage}
          </div>
        )}
      </header>

      {(data || []).map(item => (
        <div key={item.id} className="mb-3">
          <Item
            {...item}
            metaLabel={orderingVal === ORDER_CREATED ? 'created' : 'updated'}
            onEditComplete={updateCacheKey}
            onDeleteSuccess={updateCacheKey}
          />
        </div>
      ))}

      {showEmptyMessage && <div><em>No items to display.</em></div>}
    </div>
  );
};

// VenueModeration.propTypes = {

// };

export default VenueModeration;
